import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Intercom, shutdown } from '@intercom/messenger-js-sdk';
import { AuthAppService } from 'avn/services/auth-app/auth-app.service';
import { Auth0UiService } from 'avn/services/auth0-serv.service';
import { Constants } from 'avn/services/constants';
import { StoreService } from 'avn/services/store.service';

@Component({
  selector: 'app-mega-menu-mobile',
  templateUrl: './mega-menu-mobile.component.html',
  styleUrls: ['./mega-menu-mobile.component.scss']
})
export class MegaMenuMobileComponent implements OnInit {
  constructor(
    private dialogRef: MatDialogRef<MegaMenuMobileComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private store: StoreService,
    private router: Router,
    private auth: AuthAppService,
    private auth0: Auth0UiService
  ) {}

  selectedMain: 'wellbeing' | 'others' | '' = '';
  selectedGroup: 'Physical' | 'Mental' | 'Natural' | 'Fitness' | 'Online Services' | 'Health Conditions' | '' = '';
  selectedService: any;

  hasBusiness = false;
  isWellbeingOwner = false;

  headerCategories: any = {};
  healthConditionList: any[] = [];
  trinityLoggedUser: any;
  hmacHash = '';
  name = 'TRINITY-USER';
  platform = 'TRINITY';

  ngOnInit(): void {
    this.auth.trinityLoggedUser.subscribe((user) => {
      this.trinityLoggedUser = user;
      this.hasBusiness = user?.businesses?.length > 0 || false;
      this.isWellbeingOwner = user?.is_wellbeing_owner || false;
    });
  }

  fetchBusinessRouting() {
    const businesses = this.trinityLoggedUser.businesses;
    const business_id = businesses[0].uuid;

    return ['/business/' + business_id];
  }

  closeModal() {
    this.dialogRef.close();
  }

  goBackFromGroups() {
    this.selectedGroup = '';
    if (this.selectedMain === 'others') {
      this.selectedMain = '';
    }
  }

  goToServicePage(service: any, suburb: any) {
    const url = `/search/${service.slug}/${suburb.slug}`;
    this.router.navigate([url]);
    this.closeModal();
  }

  goToCategoryPage(service: any, suburb: any) {
    let url = `/category/${service.slug}`;
    if (suburb) {
      url += `/${suburb.slug}`;
    }
    this.router.navigate([url]);
    this.closeModal();
  }

  goToHealthConditionPage(service: any, suburb: any) {
    const url = `/${service.name.toLowerCase().replace(/ /g, '-')}/${suburb.city.toLowerCase().replace(/ /g, '-')}/${
      suburb.post_code
    }`;
    this.router.navigate([url]);
    this.closeModal();
  }

  selectService(item: any) {
    if (this.selectedGroup !== 'Online Services') {
      this.selectedService = item;
      return;
    }
    this.router.navigate([`/online/${item.slug}`]);
    this.closeModal();
  }

  signOut() {
    shutdown();
    this.auth0.signOut();
    this.inItIntercom();
  }

  inItIntercom() {
    // For anonymous users after sign out - no email, let Intercom automation ask for it
    Intercom({
      app_id: Constants.INTERCOM_CONFIG.appId,
      user_name: `Anonymous ${this.platform} User`,
      platform: this.platform
    });
  }
}
